var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
import { RETURN_METHOD } from '../constants/general';
export var useSummaryStore = create()(function () { return ({
    orderId: '',
    emailId: '',
    selectedReturnItems: [],
    returnTrackingNumbers: [],
    returnByDate: '',
    returnMethod: RETURN_METHOD.UPS_DROP_OFF,
    sorisId: '',
    isMultiAddressReturn: false,
    multipleReturnBoxes: [],
    shipments: undefined,
}); });
export var setSummarySession = function (_a) {
    var orderId = _a.orderId, emailId = _a.emailId, selectedReturnItems = _a.selectedReturnItems, returnTrackingNumbers = _a.returnTrackingNumbers, returnByDate = _a.returnByDate, trackingDetails = _a.trackingDetails, refundValues = _a.refundValues, returnMethod = _a.returnMethod, sorisId = _a.sorisId, sorisQRCode = _a.sorisQRCode, isMultiAddressReturn = _a.isMultiAddressReturn, multipleReturnBoxes = _a.multipleReturnBoxes, shipments = _a.shipments;
    return useSummaryStore.setState({
        orderId: orderId,
        emailId: emailId,
        selectedReturnItems: selectedReturnItems,
        returnTrackingNumbers: returnTrackingNumbers,
        returnByDate: returnByDate,
        trackingDetails: trackingDetails,
        refundValues: refundValues,
        returnMethod: returnMethod,
        sorisId: sorisId,
        sorisQRCode: sorisQRCode,
        isMultiAddressReturn: isMultiAddressReturn,
        multipleReturnBoxes: multipleReturnBoxes,
        shipments: shipments,
    });
};
export var setRefundValues = function (value) {
    return useSummaryStore.setState({ refundValues: value });
};
export var _mockSummaryStore = function (mockedState) {
    return useSummaryStore.setState(function (state) { return (__assign(__assign({}, state), mockedState)); });
};
